import { useEffect, useState } from "react";
import { BadgeCheck } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";

export const ActivationNotice = () => {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    const h = (e) => setInfo(e.detail);
    window.addEventListener("lw-activation", h);
    return () => window.removeEventListener("lw-activation", h);
  }, []);
  if (!info) return null;
  const { used, max, remaining, new_activation: fresh } = info;
  return (
    <Dialog open onOpenChange={(o) => !o && setInfo(null)}>
      <DialogContent className="w-[calc(100%-2rem)] rounded-lg sm:max-w-sm" data-testid="activation-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><BadgeCheck className="h-5 w-5 text-emerald-600" />PaperLite Pro activated</DialogTitle>
          <DialogDescription>{fresh ? "This device has been added to your licence." : "This device was already activated with this licence."}</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3 text-center">
          <div className="rounded-lg border p-3"><div className="text-2xl font-semibold tabular-nums" data-testid="activation-used">{used} of {max}</div><div className="text-xs text-muted-foreground">activations used</div></div>
          <div className="rounded-lg border p-3"><div className="text-2xl font-semibold tabular-nums text-primary" data-testid="activation-remaining">{remaining}</div><div className="text-xs text-muted-foreground">remaining</div></div>
        </div>
        {max <= 10 && <div className="flex gap-1.5 justify-center" aria-hidden>{Array.from({ length: max }, (_, i) => <span key={i} className={`h-2 w-8 rounded-full ${i < used ? "bg-primary" : "bg-muted"}`} />)}</div>}
        <p className="text-xs text-muted-foreground">Licence key <span className="font-mono text-foreground">{info.key}</span>{remaining ? ` can be activated on ${remaining} more device${remaining > 1 ? "s" : ""}.` : " has no activations left."}</p>
        <DialogFooter><Button onClick={() => setInfo(null)} data-testid="activation-ok-btn">Got it</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
